// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"5a109394","488":"d292933d","747":"8abcfbb2","993":"59c38490"}[chunkId] + ".chunk.js";
};